import axios from "axios";

export default function createRecipe({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ userChoiceValues = {} }) =>
    axios({
      url: process.env.REACT_APP_CREATE_RECIPE_URL,
      method: "POST",
      cancelToken: source.token,
      data: userChoiceValues,
    }).then((response) => {
      return response.data;
    });
}
